import { mapActions } from 'vuex';

function created() {
	const breadCrumbs = JSON.parse(localStorage.getItem('bc'));
	if (breadCrumbs) {
		this.$updateBreadCrumbsFromLocalStorage(breadCrumbs);
	}
	const currentSubsidiary = JSON.parse(localStorage.getItem('cs'));
	if (currentSubsidiary) {
		this.$setCurrentSubsidiary(currentSubsidiary);
	}
}

export default {
	created,
	methods: {
		...mapActions('subsidiary', {
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
		}),
		...mapActions('route', {
			$updateBreadCrumbsFromLocalStorage: 'LOCAL_STORAGE_BREAD_CRUMBS',
		}),
	},
};



// WEBPACK FOOTER //
// ./src/mixins/updateOnReload.js